import { FC, useMemo, useCallback, ReactNode } from 'react';
import { Form } from 'react-final-form';
import { useSelector } from 'react-redux';

import { getBookingsState } from 'src/store/bookings/selectors';
import { bookingsActions } from 'src/store/bookings/slice';
import { BookingsPageRole } from 'src/store/bookings/types';
import { useAppDispatch } from 'src/store/useAppDispatch';

import { useMyBookingsPageRole } from '../../MyBookingsPageRole/MyBookingsPageRoleProvider';

export interface MyBookingsFiltersFormValues {
  from: string | undefined;
  to: string | undefined;
  isAuthor: boolean;
}

export interface MyBookingsFiltersFormProps {
  children?: ReactNode;
}

export const MyBookingsFiltersForm: FC<MyBookingsFiltersFormProps> = ({
  children,
}) => {
  const dispatch = useAppDispatch();
  const { from, to, role } = useSelector(getBookingsState);
  const { setRole } = useMyBookingsPageRole();

  const initialValues = useMemo(
    (): MyBookingsFiltersFormValues => ({
      from,
      to,
      isAuthor: role === BookingsPageRole.Author,
    }),
    [from, role, to],
  );

  const applyFilters = useCallback(
    (values: MyBookingsFiltersFormValues) => {
      dispatch(bookingsActions.applyFilters(values));
      setRole(
        values.isAuthor
          ? BookingsPageRole.Author
          : BookingsPageRole.Responsible,
      );
    },
    [dispatch, setRole],
  );

  return (
    <Form onSubmit={applyFilters} initialValues={initialValues}>
      {() => children}
    </Form>
  );
};
